import React from 'react';
import {
  graphql,
  createRefetchContainer,
} from 'react-relay';

import { withRouter } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import BrokerActivityDetails from '../activity/BrokerActivityDetails';
import { useCommonStyles } from '../common/Styles';
import BrokerActivityActions from './BrokerActivityActions';
import TableFieldMeta from '../../common/TableFieldMeta';
import BrokerActivityTableFieldMeta from './BrokerActivityTableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import InnerTabFilterGridItemDateField from '../common/innerTab/InnerTabFilterGridItemDateField';
import InnerTabFilterSelectField from '../common/innerTab/InnerTabFilterSelectField';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import TablePaginator from '../common/TablePaginator';
import MsgRouter from '../../common/MsgRouter';
import ProcessForm from './forms/ProcessForm';
import InnerTabFilterToggleButtonGroup from '../common/innerTab/InnerTabFilterToggleButtonGroup';
import RTTableRenderer from '../common/table/RTTableRenderer';

function SalesTaxList(props) {
  const { viewer, relay, filter } = props;
  const classes = useCommonStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [detailsOpen, setDetailsOpen] = React.useState(false);
  const [brokerActivity, setBrokerActivity] = React.useState(false);
  const [msgRouter] = React.useState(new MsgRouter());
  filter.setRelay(relay);

  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.processedAt,
    TableFieldMeta.processedBy,
    BrokerActivityTableFieldMeta.currency,
    TableFieldMeta.field('taxableDescription', 'Description', { width: 300 }),
    BrokerActivityTableFieldMeta.isin,
    BrokerActivityTableFieldMeta.reportDate,
    TableFieldMeta.field('salesTax', 'Sales Tax', { align: 'right' }),
    {
      id: 'actions',
      accessor: node => node,
      Header: 'Actions',
      Cell: row => (
        <BrokerActivityActions
          brokerActivity={row.value}
          onProcess={() => {
            setBrokerActivity(row.value);
            setDrawerOpen(true);
          }}
          onShowDetails={() => {
            setBrokerActivity(row.value);
            setDetailsOpen(true);
          }}
        />
      ),
    },
    BrokerActivityTableFieldMeta.ignore(msgRouter),
    TableFieldMeta.notes(row => row.value),
  ];

  return (
    <div className={classes.innerTabRoot}>
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        {/*<div*/}
        {/*  tabIndex={0}*/}
        {/*  role="button"*/}
        {/*>*/}
        {/*  <ProcessForm brokerActivity={brokerActivity} close={() => setDrawerOpen(false)} />*/}
        {/*</div>*/}
        <ProcessForm
          key={brokerActivity ? brokerActivity.id : 'procForm'}
          brokerActivity={brokerActivity}
          onClose={() => setDrawerOpen(false)}
          showToAccount
          showSibling={false}
          heading="Process Sales Tax"
          nodeName="IBSalesTaxNode"
        />
      </Drawer>

      <Drawer anchor="right" open={detailsOpen} onClose={() => setDetailsOpen(false)}>
        <div
          tabIndex={0}
          role="button"
        >
          <BrokerActivityDetails brokerActivity={brokerActivity} />
        </div>
      </Drawer>

      <BaseGridContainer>
        <InnerTabFilterGridItemTextField
          id="search-filter"
          label="Custom Search"
          helperText="description"
          onChange={e => filter.updateVar('search', e.target.value)}
        />

        <InnerTabFilterSelectField
          enumType="Currency"
          label="Currency"
          halfWidth
          value={filter.params.currency}
          onChange={e => filter.updateVar('currency', e.target.value)}
        />

        <InnerTabFilterGridItemDateField
          value={filter.params.reportDate}
          onChange={value => filter.updateVar('reportDate', value)}
          label="Report Date"
        />

        <InnerTabFilterToggleButtonGroup
          enumType={[
            { name: null, description: '∅' },
            { name: false, description: 'Yes' },
            { name: true, description: 'No' },
          ]}
          helperText="Processed?"
          defaultValue={filter.params.processedAt_Isnull}
          onChange={newVal => filter.updateVar('processedAt_Isnull', newVal)}
        />

        <InnerTabFilterToggleButtonGroup
          enumType={[
            { name: null, description: '∅' },
            { name: true, description: 'Yes' },
            { name: false, description: 'No' },
          ]}
          helperText="Ignored?"
          defaultValue={filter.params.ignored}
          onChange={newVal => filter.updateVar('ignored', newVal)}
        />

        <Grid item xs={12}>
          <TablePaginator
            columns={columns}
            filter={filter}
            getDataNode={() => (viewer ? viewer.ibSalesTaxes : null)}
            tableRender={RTTableRenderer}
          />
        </Grid>
      </BaseGridContainer>
    </div>
  );
}

const query = graphql`
  query SalesTaxListQuery (
    $first: Int
    $offset: Int
    $search: String
    $reportDate: Date
    $currency: String
    $processedAt_Isnull: Boolean
    $ignored: Boolean
  ) {
    viewer {
      ...SalesTaxList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        reportDate: $reportDate
        currency: $currency
        processedAt_Isnull: $processedAt_Isnull
        ignored: $ignored
      )
    }
  }
`;

const container = createRefetchContainer(
  SalesTaxList,
  {
    viewer: graphql`
      fragment SalesTaxList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10}
        offset: {type: Int}
        search: {type: String}
        reportDate: {type: Date}
        currency: {type: String}
        processedAt_Isnull: {type: Boolean}
        ignored: {type: Boolean}
      ) {
        ibSalesTaxes(
          first: $first
          offset: $offset
          search: $search
          reportDate: $reportDate
          currency: $currency
          processedAt_Isnull: $processedAt_Isnull
          orderBy: "-createdAt"
          ignored: $ignored
        ) {
          edges {
            node {
              ...IBSalesTax_all @relay(mask: false)
            }
          }
          count
        }
      }
    `,
  },
  query,
);

export default withRouter(createQueryRendererProgressV2(
  query,
  container,
  {},
  {
    search: null,
    reportDate: null,
    symbol: null,
    ibConId: null,
    currency: null,
    processedAt_Isnull: null,
    ignored: null,
  },
  {
    debounceFields: ['search', 'symbol'],
  },
));
